<script setup lang="ts">
import { OrToastContainerV3, OrNotificationV3 } from '@onereach/ui-components';

import { useErrorHandler } from './utils/error';
const {
  errorText,
  discardError,
} = useErrorHandler();
</script>

<template>
  <OrNotificationV3
    v-if="errorText"
    class="error-notification absolute z-[100] w-[calc(100%-(2*theme(spacing.3xl)))] m-3xl"
    variant="error"
    @close="discardError"
  >
    {{ errorText }}
  </OrNotificationV3>
  <div class="app flex flex-col">
    <OrToastContainerV3 />
    <router-view />
  </div>
</template>

<style>
html,
body,
#app,
.app {
  @apply h-full;
}

html,
body {
  width: 100%;
  height: 100dvh;
  height: -webkit-fill-available;
}
</style>
